import { DisplayAuthoringPropertyPipe, IsRequiredPropertyPipe, SerializedPropertyMapPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { SensorActionSequenceComponentModule } from '../sensor-action-sequence';
import { ExtensionsPropertiesComponent } from './extensions-properties.component';

const WIDGETS: Type<any>[] = [
	CardComponentModule,
	ContainerComponentModule,
	LabelComponentModule,
	TextComponentModule,
	InputComponentModule,
	SensorActionSequenceComponentModule
];

@NgModule({
	imports: [
		CommonModule,
		DisplayAuthoringPropertyPipe,
		IsRequiredPropertyPipe,
		SerializedPropertyMapPipe,
		...WIDGETS
	],
	declarations: [ExtensionsPropertiesComponent],
	exports: [ExtensionsPropertiesComponent]
})
export class ExtensionsPropertiesComponentModule {

}
